module.exports = __webpack_public_path__ + "img/product_banner-old.49adcf68.png";